/*global window*/
MOVE.LDP.Photos = (function (LDP) {
  "use strict";

    var goToImage,
        preloadPhotos,
        loadPhoto,
        initAdsCloseButton,
        photoGallery;

    var init = function (options, onChangedCallBack, onDragCallBack) {
        photoGallery = options.target;
        photoGallery.owlCarousel({
          items: options.items,
          loop: true,
          margin: options.margin,
          startPosition: options.currentIndex,
          navSpeed: 100,
          lazyLoad: true,
          dots: false,
          nav: true,
          touchDrag: options.touchDrag,
          mouseDrag: options.mouseDrag,
          responsiveClass: options.responsiveClass,
          responsive: options.responsive,
          navText: [
            "<div class='gallery-arrows arrow-left hidden-xs hidden-xxs' data-omtag='edw:ldp:photo:prev'><i class='ra ra-chevron-left' data-omtag='edw:ldp:photo:prev'></i></div>",
            "<div class='gallery-arrows arrow-right hidden-xs hidden-xxs' data-omtag='edw:ldp:photo:next'><i class='ra ra-chevron-right' data-omtag='edw:ldp:photo:next'></i></div>"
          ],
          navContainer: (options.navigationContainer && ($(options.navigationContainer).length > 0)) ? options.navigationContainer : '',
          onDrag: function() {
            if (onDragCallBack) {
              onDragCallBack();
            }
          },
          onChanged: function(e) {
            if (!e.namespace || e.property.name !== 'position'){
              return;
            }
            var index = e.relatedTarget.relative(e.item.index);
            preloadPhotos(photoGallery, index);
            onChangedCallBack(e.item.count, index);
            // Update the url only when index is undefined.
            if(index !== undefined) {
              window.history.replaceState("", "RdcNext", '#photo' + index);
            }
          }
        });
        initAdsCloseButton();
    };

    var closePhotoMrectAds = function (photos) {
      var items = photos.find("div.owl-item:not('.cloned')");
      if (items.length > 0) {
        photos.trigger('remove.owl.carousel', items.length - 1); //remove owl carousel container item for the ads
        photos.trigger('prev.owl.carousel'); // stay at last photo
      }
    };

    initAdsCloseButton = function() {
        $('.ldp-photo-wrap #photomrect1AdsClose').off('click').click(
            function(event) {
              $(event.target).parents('.fsgallery-ad').remove();  //remove the ads div
              closePhotoMrectAds($('#ldpPhotos'));
            }
        );
        $('.ldp-photo-cta #photomrect2AdsClose').off('click').click(
            function(event) {
              $(event.target).parents('.fsgallery-ad').remove();  //remove the ads div
              closePhotoMrectAds($('#ldpPhotoGallery'));
            }
        );
    };

    $(document).keydown(function (e) {
      var photos = $('.ldp-photos', e.target);
      if (0 === photos.length) {
        return;
      }
      if (e.keyCode === 37) {
          photos.trigger('prev.owl.carousel');
      } else if (e.keyCode === 39) {
          photos.trigger('next.owl.carousel');
      }
    });

    //preload previous and next photos that has not been alrady loaded
    preloadPhotos = function(photos, index) {
      var items = photos.find("div.owl-item:not('.cloned')");
      loadPhoto(items.eq(index).next());
      loadPhoto(items.eq(index).prev());
    };

    loadPhoto = function(photoDiv) {
      if (photoDiv) {
        var photo = photoDiv.find("img");
        if (photo.length === 1){
          if (photo.attr("src") === "") {
            photo.attr("src", photo.data("src"));
          }
          return;
        }
        photo.each(function(){
          if ($(this).attr("src") === "") {
            $(this).attr("src", $(this).data("src"));
          }
       });
      }
    };

    LDP.Photos =
    {
        init: init,
        goToImage: goToImage,
        preloadPhotos: preloadPhotos
    };

    return LDP.Photos;

})(MOVE.LDP || {});



// WEBPACK FOOTER //
// ./ldp/common_platform/critical_components/ldp_photos.js